import React from 'react';
import { Section } from './ui/Section';
import { Check } from 'lucide-react';
export function BenefitsSection() {
  const benefits = ['Abres el refri y ya no negocias contigo misma', 'Dejas de gastar en delivery por cansancio', "Comes completo sin 'esfuerzo mental' extra", 'Reduces desperdicio con compras estructuradas', 'Control sin rigidez'];
  return <Section background="white" data-id="element-6">
      <div className="max-w-5xl mx-auto" data-id="element-7">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-8">
          <div data-id="element-9">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1F2937] mb-4" data-id="element-10">
              Menos culpa. Menos gasto.
              <br data-id="element-11" />
              <span className="text-[#1e3a8a]" data-id="element-12">Más paz mental.</span>
            </h2>
            <p className="text-lg text-[#4B5563] mb-6" data-id="element-13">
              Este sistema está diseñado para la vida real, con días caóticos y
              energía limitada.
            </p>
            <div className="grid grid-cols-2 gap-4" data-id="element-14">
              <div className="bg-[#EFF6FF] p-4 rounded-lg text-center border border-[#DBEAFE]" data-id="element-15">
                <span className="block text-3xl font-bold text-[#1e3a8a]" data-id="element-16">
                  15 min
                </span>
                <span className="text-sm text-[#4B5563]" data-id="element-17">Por semana</span>
              </div>
              <div className="bg-[#EFF6FF] p-4 rounded-lg text-center border border-[#DBEAFE]" data-id="element-18">
                <span className="block text-3xl font-bold text-[#1e3a8a]" data-id="element-19">
                  0%
                </span>
                <span className="text-sm text-[#4B5563]" data-id="element-20">Desperdicio</span>
              </div>
            </div>
          </div>

          <div className="bg-[#EFF6FF] p-6 md:p-8 rounded-xl border border-[#DBEAFE]" data-id="element-21">
            <h3 className="text-xl font-bold text-[#1F2937] mb-5" data-id="element-22">
              Lo que cambia con 3–3–7
            </h3>
            <ul className="space-y-3" data-id="element-23">
              {benefits.map((benefit, i) => <li key={i} className="flex items-start" data-id="element-24">
                  <div className="bg-[#1e3a8a] rounded-full p-1 mt-0.5 mr-3 flex-shrink-0" data-id="element-25">
                    <Check className="w-3 h-3 text-white" data-id="element-26" />
                  </div>
                  <span className="text-[#4B5563]" data-id="element-27">{benefit}</span>
                </li>)}
            </ul>
            <p className="text-lg text-[#1F2937] italic mt-6 pt-6 border-t border-[#DBEAFE]" data-id="element-28">
              "No es disciplina dura… es{' '}
              <span className="text-[#1e3a8a] font-bold not-italic" data-id="element-29">calma</span>
              ."
            </p>
          </div>
        </div>
      </div>
    </Section>;
}